import React from "react";

import { IconInstagram, Link, SanityImage, SanityImageProps } from "@bared/ui";

export interface InstagramCardProps {
  title: string;
  productHandle?: string;
  image: SanityImageProps["data"];
}

export function InstagramCard({
  title,
  image,
  productHandle,
}: InstagramCardProps) {
  // Remove new lines from titles.
  const cleanTitle = (title ?? "").replace(/\r?\n|\r/g, " ");

  return (
    <div className="px-micro first-of-type:pl-zero md:px-mini">
      {!!productHandle ? (
        <Link variant="plain" href={`/products/${productHandle}`}>
          <div className="relative">
            <IconInstagram className="absolute right-mini top-mini h-mini text-white md:right-midi md:top-midi" />
            <SanityImage
              className="aspect-4-5 object-cover"
              data={image}
              maxWidth="100vw"
              altText={cleanTitle}
            />
          </div>
        </Link>
      ) : (
        <div className="relative">
          <IconInstagram className="absolute right-mini top-mini h-mini text-white md:right-midi md:top-midi" />
          <SanityImage
            className="aspect-4-5 object-cover"
            data={image}
            maxWidth="100vw"
            altText={cleanTitle}
          />
        </div>
      )}
    </div>
  );
}
